import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function Afiliacion() {
  const [body, setBody] = useState("");
  useEffect(() => {
    api.get("/content/afiliacion").then((r) => setBody(r.data.data?.body || ""));
  }, []);
  return (
    <div className="space-y-6 animate-in fade-in duration-500" data-testid="afiliacion-page">
      <header className="py-4">
        <div className="text-xs uppercase tracking-[0.25em] text-primary font-bold">Afiliación</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-1">Cuidarnos entre los nuestros</h1>
      </header>
      <div className="bg-white rounded-2xl border border-border p-6 whitespace-pre-line text-base leading-relaxed" data-testid="afiliacion-body">
        {body}
      </div>
    </div>
  );
}
